module.exports = __webpack_public_path__ + "assets/img/idTradesmart.a1e54bbf.jpg";